export const system = {
  window: typeof window === 'undefined' ? global : window
};
